export const generateSeatGeekLoginLink = (seatgeekIssuer, seatGeekTeamSlugInScope, seatgeekClientId, seatGeekTeamSlug) => {
  return `${seatgeekIssuer}?scope=view-${seatGeekTeamSlugInScope}-crm-id,offline_access&client_id=${seatgeekClientId}&create_crm_domain_slug=${seatGeekTeamSlug}`
}
